import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as urlTemplate from 'url-template';

import { UpsellResponse } from '@shared/flight-itinerary/entities/upsell-flights';
import { upsellApi } from '@upsell/upsell.api';
import { FetchFlightsOptionPayload } from '@flight-results/entities/fetch-flights-option.payload';
import { UpsellPackagePayload } from '@packages/packages-result/entities/upsell';
import { packagesResultApi } from '@packages/packages-result/packages-result.api';
import { getUriFlightKeys } from '@flight-results/mappers/flight-keys.mapper';

@Injectable()
export class UpsellService {

  constructor(
    private readonly http: HttpClient
  ) { }

  public fetchUpsellOptions(optionId: number, sessionToken: string, searchId: string): Observable<UpsellResponse> {
    const headers = new HttpHeaders({
      'ignoreLoadingBar': '',
      'Authorization': sessionToken
    });
    const url = urlTemplate.parse(upsellApi.air_upsell).expand({
      optionId: optionId,
      searchId: searchId
    });
    return this.http.get<UpsellResponse>(url, { headers: headers });
  }

  public fetchUpsellOptionsBySector(
    OptionId: number, SessionToken: string, SearchId: string, PreviousOptions: number[]
  ): Observable<UpsellResponse> {
    const headers = new HttpHeaders({
      'ignoreLoadingBar': '',
      'Authorization': SessionToken
    });
    const payload = {
      SearchId,
      OptionId,
      SectorNumber: 1,
      PreviousOptions,
      SessionToken,
      extendedInformation: true
    };
    const url = upsellApi.air_upsell_by_sector;
    return this.http.post<UpsellResponse>(url, payload, { headers });
  }

  public fetchFlightsOption(payload: FetchFlightsOptionPayload): Observable<{ OptionId: number }> {
    const headers = new HttpHeaders({
      'ignoreLoadingBar': '',
      'Authorization': payload.SessionToken
    });
    let url = urlTemplate.parse(upsellApi.air_option).expand({
      searchId: payload.SearchId
    });
    const flightKeys = getUriFlightKeys(payload?.FlightKeys);
    url = `${url}${flightKeys}`;
    return this.http.get<{ OptionId: number }>(url, { headers });
  }

  public fetchPackageUpsellAir(payload: UpsellPackagePayload): Observable<UpsellResponse> {
    const url = urlTemplate.parse(packagesResultApi.package_upsell_whole_trip).expand({
      searchId: payload.SearchId,
      optionIdAir: payload.optionIdAir,
      rateId: payload.rateId,
      hotelOptionId: payload.hotelOptionId,
      extendedInformation: true
    });
    const headers = this.getAuthorizationHeader(payload.SessionToken);
    return this.http.get<UpsellResponse>(url, { headers });
  }

  public fetchPackageAirFlightsOption(payload: FetchFlightsOptionPayload): Observable<{ OptionId: number }> {
    const headers = this.getAuthorizationHeader(payload.SessionToken);
    let url = urlTemplate.parse(packagesResultApi.air_option).expand({ searchId: payload.SearchId });
    const flightKeys = getUriFlightKeys(payload?.FlightKeys);
    url = `${url}${flightKeys}`;
    return this.http.get<{ OptionId: number }>(url, { headers });
  }

  private getAuthorizationHeader(token: string): HttpHeaders {
    return new HttpHeaders({ 'ignoreLoadingBar': '', 'Authorization': token });
  }
}
